import type { HeaderMenuItem, FooterMenuItem, FooterMenuGroup } from '~/shared/interfaces/menu'
import { POLICY_LINK, ADVERTISING_POLICY_LINK, TERMS_LINK } from '~/shared/const/links'
import maxBtn from '~/assets/icons/max-btn.svg'
import telegramBtn from '~/assets/icons/telegram-btn.svg'

export const headerMenuTop: Array<HeaderMenuItem> = [
  {
    name: 'Вакансии',
    url: '/vacancies',
  },
  {
    name: 'Резюме',
    url: '/resume-list',
  },
  {
    name: 'Вузы',
    url: '/universities',
  },
  {
    name: 'Колледжи',
    url: '/colleges',
  },
  {
    name: 'Калькулятор ЕГЭ',
    url: '/calculator-ege',
  },
  {
    name: 'Наставничество',
    url: '/tutor',
  },
  {
    name: 'Журнал',
    url: '/news',
  },
  {
    name: 'Цифровой лекторий',
    url: '/digital-lecture',
  },
  {
    name: 'Научные работы',
    url: '/research-showcase',
  },
  {
    name: 'Запросы бизнеса',
    url: '/nauchnye-razrabotki',
  },
  {
    name: 'Агроклассы',
    url: 'https://agroclasses.svoevagro.ru/?utm_source=svoevagro',
  },
  {
    name: 'Карьерные маршруты',
    url: '/career-routes',
  },
  {
    name: 'Работодатели',
    url: '/employer',
  },
]

export const headerMenuBottom: Array<HeaderMenuItem> = [
  {
    name: 'В поисках работы',
    url: '/looking-for-job',
  },
  {
    name: 'Витрина стажировок и практик',
    url: '/stazhirovka',
  },
  {
    name: 'Для работодателей',
    url: '/for-employers',
  },
]

export const footerMenusGroups: Array<FooterMenuGroup> = [
  {
    name: 'О нас',
    isButtonBlock: false,
    items: [
      {
        name: 'О Россельхозбанке',
        url: 'https://www.rshb.ru/about/',
      },
    ],
  },
  {
    name: 'Пользователям',
    isButtonBlock: false,
    items: [
      {
        name: 'Вузы',
        url: '/universities',
      },
      {
        name: 'Журнал',
        url: '/news',
      },
      {
        name: 'Цифровой лекторий',
        url: '/digital-lecture',
      },
      {
        name: 'Стать спикером цифрового лектория',
        url: '/digital-lecture#speaker-form',
      },
      {
        name: 'Научные работы',
        url: '/research-showcase',
      },
      {
        name: 'Поддержка',
        url: '/support',
      },
    ],
  },
  {
    name: 'По всем вопросам',
    isButtonBlock: true,
    items: [
      {
        name: 'Чат-бот в MAX',
        url: 'https://max.ru/ya_v_agro_bot',
        icon: maxBtn,
      },
      {
        name: 'Чат-бот в Telegram',
        url: 'https://t.me/konkurs_yavagro_bot',
        icon: telegramBtn,
      },
    ],
  },
]

export const footerBottomMenu: Array<FooterMenuItem> = [
  {
    name: 'Политика обработки персональных данных',
    url: POLICY_LINK,
  },
  {
    name: 'Пользовательское соглашение',
    url: TERMS_LINK,
  },
  {
    name: 'Согласие на получение рекламы',
    url: ADVERTISING_POLICY_LINK,
  },
]
